import React from 'react';

export const currentEnvironment = import.meta.env.VITE_ENVIRONMENT;

type Mode = 'show' | 'hide';
type GetEnvironmentVisibilityProps = {
  mode: Mode;
  local?: boolean;
  dev?: boolean;
  test?: boolean;
  demo?: boolean;
  prod?: boolean;
  testSf?: boolean;
};
type EnvironmentVisibilityProps = GetEnvironmentVisibilityProps & {
  children: React.ReactNode;
};

export const ENVIRONMENTS = {
  demo: 'demo',
  dev: 'development',
  local: 'local',
  prod: 'prod',
  test: 'test',
  testSf: 'test_sf',
};

export const getEnvironmentVisibility = ({
  mode,
  local,
  dev,
  test,
  demo,
  prod,
  testSf,
}: GetEnvironmentVisibilityProps) => {
  const allowedEnvironments = [];

  if (mode === 'hide') {
    !local && allowedEnvironments.push(ENVIRONMENTS.local);
    !demo && allowedEnvironments.push(ENVIRONMENTS.demo);
    !dev && allowedEnvironments.push(ENVIRONMENTS.dev);
    !prod && allowedEnvironments.push(ENVIRONMENTS.prod);
    !test && allowedEnvironments.push(ENVIRONMENTS.test);
    !testSf && allowedEnvironments.push(ENVIRONMENTS.testSf);
  } else if (mode === 'show') {
    local && allowedEnvironments.push(ENVIRONMENTS.local);
    demo && allowedEnvironments.push(ENVIRONMENTS.demo);
    dev && allowedEnvironments.push(ENVIRONMENTS.dev);
    prod && allowedEnvironments.push(ENVIRONMENTS.prod);
    test && allowedEnvironments.push(ENVIRONMENTS.test);
    testSf && allowedEnvironments.push(ENVIRONMENTS.testSf);
  }

  return allowedEnvironments.includes(currentEnvironment);
};

const EnvironmentVisibility = ({ children, ...props }: EnvironmentVisibilityProps) => {
  const showContent = getEnvironmentVisibility(props);

  return showContent ? <>{children}</> : null;
};

export default EnvironmentVisibility;
